import { createConsumer } from "@rails/actioncable";

let consumer = null;

// Single shared consumer for the v2 SPA. The /websocket handshake is a
// same-origin upgrade, so the Devise session cookie authenticates it
// (app/channels/application_cable/connection.rb) - no token needed.
export default function getConsumer() {
  if (!consumer) {
    consumer = createConsumer("/websocket");
  }
  return consumer;
}
